import { render, staticRenderFns } from "./RoleSidebar.vue?vue&type=template&id=643643a1&"
import script from "./RoleSidebar.vue?vue&type=script&lang=js&"
export * from "./RoleSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports